import React from 'react';
import Hero from '../components/home/Hero';
import OurServices from '../components/home/OurServices';
import MemberBenefits from '../components/home/MemberBenefits';
import FuturePlans from '../components/home/FuturePlans';
import Stats from '../components/home/Stats';
import HomeCareers from '../components/home/HomeCareers';
import WhyChooseUs from '../components/home/WhyChooseUs';
import HomeContactForm from '../components/home/HomeContactForm';
import OurBranches from '../components/common/OurBranches';

import FinancialCalculators from '../components/home/FinancialCalculators';

const Home = () => {
    return (
        <div className="home-page">
            <Hero />
            <Stats />
            <OurServices />
            <FinancialCalculators />
            <MemberBenefits />
            <FuturePlans />
            <HomeCareers />
            <WhyChooseUs />
            <HomeContactForm />
            <OurBranches />
        </div>
    );
};

export default Home;
